// The page's vocabulary lives in ../styles; this file adds only what the panels need on
// top (tables, badges, skeleton bars). PANEL here is the block variant: the panels lay
// their children out themselves, so they do not take the page's flex-column panel.
import { FOCUS, MOTION as EASE, PANEL_HEADER, PANEL_TITLE, ICON_BUTTON } from '../styles';

export { PANEL_HEADER, PANEL_TITLE, ICON_BUTTON };
export const PANEL = 'min-w-0 overflow-hidden rounded-lg bg-surface-container-low';
export const PANEL_BADGE = 'shrink-0 whitespace-nowrap text-xs tabular-nums text-on-surface-variant';

export const BUTTON_SHAPE =
  `np-state inline-flex items-center gap-1 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium disabled:cursor-not-allowed ${EASE} ${FOCUS}`;
export const QUIET_BUTTON =
  `${BUTTON_SHAPE} bg-surface-container-highest text-on-surface disabled:text-on-surface-variant`;
export const FILLED_BUTTON =
  `${BUTTON_SHAPE} np-state-on-primary bg-primary text-on-primary`;

export const TH = 'whitespace-nowrap px-2 py-1.5 text-xs font-semibold text-on-surface-variant';
export const TD = 'px-2 py-1.5 align-top';
export const HEADER_RULE = 'border-b border-outline-variant';
export const ZEBRA = 'odd:bg-surface-container-low even:bg-surface-container';

export const SKELETON = 'rounded bg-surface-container-high';

/** "info" -> "Info": severity keys are lowercase data, labels are sentence case. */
export const severityWord = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
